module.exports = __webpack_public_path__ + "f4af684300436d830b745064bb1b0cfc.png";